import { getStoreState } from 'base/store';
import { getParamInSearch } from 'ava-util/dist/request';
import { DEBUG_APP } from 'base/config/constant';
import { addAppLogGroup, appLogActive } from '@base/common/AppDebug';

export type TData = Record<string, any>;
export type TCallBack = (res?: any) => void;

type IBridge = {
    callHandler: (name: string, data?: TData | TCallBack, callback?: TCallBack) => void;
    registerHandler: (name: string, func: TCallBack) => void;
    init: (func: (message: string, responseCallback: TCallBack) => void) => void;
}

declare global {
    interface Window {
        WebViewJavascriptBridge?: IBridge;
        WVJBCallbacks?: Array<Function>;
        WebViewAppHandlers: Record<string, TCallBack>;
    }
}

function bridgeLog(title: string, data?: Record<string, any>) {
    if (!appLogActive()) {
        return;
    }
    console.log(`----- ${title}`)
    if (data) {
        console.log(data)
    }

    addAppLogGroup(`--- ${title}`, data);
}

// 等待加载 WebViewJavascriptBridge 对象
function loadBridge(callback: (bridge: IBridge) => void) {
    if (window.WebViewJavascriptBridge) {
        callback(window.WebViewJavascriptBridge);
    } else {
        document.addEventListener('WebViewJavascriptBridgeReady', function() {
            callback(window.WebViewJavascriptBridge as IBridge);
        }, false)
    }
}

// web 调用 app 方法
export function callApp(name: string, data?: TData | TCallBack, callback?: TCallBack) {
    const {
        envName,
        ua: {
            isAndroid,
            isApp
        }
    } = getStoreState('rootStore');

    if (!isApp) {
        return;
    }

    // 支持省略data， 第二个参数传callback
    if (typeof data === 'function') {
        callback = data as TCallBack;
        data = void 0;
    }

    if(name==='trackToNative') {
        bridgeLog(`call app: ${name} ${data!.eventType}`, data);
    } else {
        bridgeLog(`call app: ${name}`, data);
    }

    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.callHandler(name, data, callback)

    } else if (isAndroid) {
        loadBridge(function(bridge) {
            bridge.init(function(message, responseCallback) {
                if (responseCallback) {
                    responseCallback({})
                }
            })

            bridge.callHandler(name, data, callback)
        })
    }

}

// web 注册方法，供 app 调用
export function registerAppHandler(name: string, func: TCallBack) {
    const {
        envName,
        ua: {
            isAndroid,
            isApp
        }
    } = getStoreState('rootStore');

    if (!isApp) {
        return;
    }

    bridgeLog(`registerHandler: ${name}`);

    const callback = (params) => {
        bridgeLog(`call web: ${name}`, params);

        if (typeof params === 'string') {
            try {
                params = JSON.parse(params)
            } catch (e) {
                console.log(`wrong response params: ${params}`);
            }
        }
        func(params);
    }

    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.registerHandler(name, callback)
    } else if (isAndroid) {
        loadBridge(function(bridge) {
            bridge.init(function(message, responseCallback) {
                if (responseCallback) {
                    responseCallback({})
                }
            })

            bridge.registerHandler(name, callback)
        });
    }
}

// 安卓需要提前init WebViewJavascriptBridge
export function initAppBridge() {
    const { ua: { isAndroid, isApp } } = getStoreState('rootStore');

    if (isApp && !window.WebViewJavascriptBridge) {
        if (getParamInSearch(DEBUG_APP) === '1') {
            mockWebViewJavascriptBridge();
            return;
        }
        if (isAndroid) {
            callApp('init');
        }
    }
}

export function mockWebViewJavascriptBridge() {
    if (window.WebViewJavascriptBridge) {
        return;
    }
    console.log('-----mockWebViewJavascriptBridge-----')
    window.WebViewJavascriptBridge = {
        init: () => {
        },
        callHandler: (name: string, data?: Record<string, any> | Function, callback?: Function) => {
            if (name === 'nativeLoginPage' || name === 'nativeUserStatus') {
                callback && callback({
                    userId: '64055074298658816',
                    loginToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3Mjg5MjcxMjksInVzZXJJZCI6MTQ4Njc2MDcwODgyNzA3NDI4LCJpYXQiOjE3MDMwMDcxMjl9.GTHiNvPnIyreirsHCz4nO4uDQL51EPFn_WFZh9PmReY',
                    accessToken: 'acc123'
                });
            }
        },
        registerHandler: (name, func) => {
            window.WebViewAppHandlers = window.WebViewAppHandlers || {};
            window.WebViewAppHandlers[name] = func;
        }
    }
}